const shouldBeArray = function (data) {
  if (Array.isArray(data))
    return data;

  return typeof data === 'object' ? Object.values(data) : [];
}

export {
  shouldBeArray
}
